module.exports = __webpack_public_path__ + "img/the-cottages-sign.d5b3a001.webp";